export enum SingletonStepsTypes {
    AutoApprovalStep = 'AutoApprovalStep',
    SelectStep = 'SelectStep',
    ReviewStep = 'ReviewStep',
}
